import { UserPreferences } from './schema-copy/api-schema';

// matchMedia is checked defensively so 'auto' degrades to 'light' on platforms
// without prefers-color-scheme support.
const darkQuery = window.matchMedia?.('(prefers-color-scheme: dark)');

export const supportsAutoTheme = !!darkQuery;

const LIGHT_META_COLOR = '#4C86F3';   // must match the default in index.html
const DARK_META_COLOR = '#181e28';    // --dr-bg-sidebar (dark)

let currentTheme: UserPreferences['theme'];

/** Apply the theme preference to the document. Call on startup and whenever the
 *  preference changes; 'auto' is kept in sync with the OS via a media query listener. */
export function applyTheme(theme: UserPreferences['theme']): void {
    currentTheme = theme ?? 'light';
    const dark = currentTheme == 'dark' || (currentTheme == 'auto' && !!darkQuery?.matches);
    document.documentElement.classList.toggle('dark', dark);
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? DARK_META_COLOR : LIGHT_META_COLOR);
}

darkQuery?.addEventListener('change', () => {
    if (currentTheme == 'auto')
        applyTheme(currentTheme);
});
